import React, { Component } from "react";
import { observer } from "mobx-react";
import LayerStore from "../../../../stores/LayerStore";
import img1 from "../../../../static-file/images/step03_img1.png";
import img2 from "../../../../static-file/images/step03_img2.png";
import img3 from "../../../../static-file/images/step03_img3.png";
import img4 from "../../../../static-file/images/step03_img4.png";
import img5 from "../../../../static-file/images/step03_img5.png";
import img6 from "../../../../static-file/images/step03_img6.png";
import img7 from "../../../../static-file/images/step03_img7.png";
import img8 from "../../../../static-file/images/step03_img8.png";
import pre_btn from "../../../../static-file/images/pre_btn.png";
import pre_btn_black from "../../../../static-file/images/pre_btn_black.png";
import next_btn from "../../../../static-file/images/next_btn.png";
import next_btn_black from "../../../../static-file/images/next_btn_black.png";
import BlankIcon from "../../../../static-file/images/logo/blank.png";

@observer
class OnboardingStep_03 extends Component {
  constructor(props) {
    super(props);
    this.state = { cnt: 1 };
    this.rootStore = {
      layerStore: LayerStore,
    };
  }

  cntUp = () => {
    const { rootStore } = this;
    if (this.state.cnt < 8) {
      this.setState({ cnt: this.state.cnt + 1 });
    } else {
      rootStore.layerStore.setChangeOnboardingStep("04");
      this.setState({ cnt: 1 });
    }
  };

  cntDown = () => {
    const { rootStore } = this;
    if (this.state.cnt > 1) {
      this.setState({ cnt: this.state.cnt - 1 });
    } else {
      rootStore.layerStore.setChangeOnboardingStep("02");
      this.setState({ cnt: 1 });
    }
  };

  render() {
    const { rootStore } = this.props;
    const layerStore = rootStore.layerStore;

    let img = BlankIcon;
    let prev_icon = BlankIcon;
    let next_icon = BlankIcon;

    if (this.state.cnt === 1) {
      img = img1;
      prev_icon = pre_btn_black;
      next_icon = next_btn;
    } else if (this.state.cnt === 2) {
      img = img2;
      prev_icon = pre_btn;
      next_icon = next_btn;
    } else if (this.state.cnt === 3) {
      img = img3;
      prev_icon = pre_btn;
      next_icon = next_btn;
    } else if (this.state.cnt === 4) {
      img = img4;
      prev_icon = pre_btn;
      next_icon = next_btn;
    } else if (this.state.cnt === 5) {
      img = img5;
      prev_icon = pre_btn;
      next_icon = next_btn;
    } else if (this.state.cnt === 6) {
      img = img6;
      prev_icon = pre_btn;
      next_icon = next_btn;
    } else if (this.state.cnt === 7) {
      img = img7;
      prev_icon = pre_btn;
      next_icon = next_btn;
    } else if (this.state.cnt === 8) {
      img = img8;
      prev_icon = pre_btn;
      next_icon = next_btn_black;
    } else {
      img = BlankIcon;
    }

    return (
      <div
        className={"layer_comm layer_common_type " + (layerStore.getChangeOnboardingStep === "03" ? " layer_open" : "")}
      >
        <div className="bg"></div>
        <div className="layer_content">
          <div className="article_common_type">
            <div className="section">
              <div className="detail">
                <div className="top">
                  <span
                    className="top_txt"
                    onClick={event => {
                      layerStore.setChangeOnboardingStep("");
                      layerStore.setLayerOnboardingView(true);
                      this.setState({ cnt: 1 });
                    }}
                  >
                    &lt; &nbsp; 처음으로
                  </span>
                  <span className="top_sub">&nbsp;&nbsp;&nbsp;Step 03. 전화 (CID) 주문접수</span>
                </div>
                <div className={this.state.cnt === 1 ? "tit" : "hide"}>
                  <p className="num">
                    <span>1</span>
                  </p>
                  <p className="txt">
                    전화주문 접수를 위해 <strong>[배달/포장 접수] 버튼을 클릭</strong>합니다.
                  </p>
                </div>
                <div className={this.state.cnt === 2 ? "tit" : "hide"}>
                  <p className="num">
                    <span>2</span>
                  </p>
                  <p className="txt">
                    <strong>[주문유형 선택 &gt; 전화번호 입력 &gt; 주소 검색]</strong>을 진행합니다.
                  </p>
                </div>
                <div className={this.state.cnt === 3 ? "tit" : "hide"}>
                  <p className="num">
                    <span>3</span>
                  </p>
                  <p className="txt">
                    <strong>메뉴</strong>를 포스에 입력합니다.
                  </p>
                </div>
                <div className={this.state.cnt === 4 ? "tit" : "hide"}>
                  <p className="num">
                    <span>4</span>
                  </p>
                  <p className="txt">
                    <strong>주방/고객 요청사항</strong>이 있는 경우, <strong>[선택]버튼을 클릭</strong>해 입력합니다.
                    <br />
                    <em>(단축키는 [배달매니저 설정 &gt; 요청메세지 관리]에서 관리합니다.)</em>
                  </p>
                </div>
                <div className={this.state.cnt === 5 ? "tit" : "hide"}>
                  <p className="num">
                    <span>5</span>
                  </p>
                  <p className="txt">
                    <strong>결제유형 선택</strong> 후 <strong>주문 접수를 완료</strong>해주세요.
                  </p>
                </div>
                <div className={this.state.cnt === 6 ? "tit" : "hide"}>
                  <p className="num">
                    <span>6</span>
                  </p>
                  <p className="txt">
                    접수한 주문은 <strong>배달매니저에서 조회 및 처리</strong>할 수 있습니다.
                  </p>
                </div>
                <div className={this.state.cnt === 7 ? "tit" : "hide"}>
                  <p className="num">
                    <span>7</span>
                  </p>
                  <p className="txt">
                    <strong>[배달/포장 현황]버튼</strong> 클릭시,<strong> 전화 주문내역을 확인</strong>할 수 있습니다.
                  </p>
                </div>
                <div className={this.state.cnt === 8 ? "tit" : "hide"}>
                  <p className="num">
                    <span>8</span>
                  </p>
                  <p className="txt">
                    더 자세한 사항은 <strong>모바일 매뉴얼</strong>을 확인해주세요.
                  </p>
                </div>
                <div className="content">
                  <p className="pre">
                    <span className="btn" onClick={this.cntDown}>
                      <img src={prev_icon} alt={"prevButton"} />
                    </span>
                    <span className={this.state.cnt === 1 ? "txt" : "hide"}>이전 안내</span>
                  </p>
                  <p className={this.state.cnt === 5 ? "img m" : "img"}>
                    <img src={img} alt={"content"} />
                  </p>
                  <p className="next">
                    <span className="btn" onClick={this.cntUp}>
                      <img src={next_icon} alt={"nextButton"} />
                    </span>
                    <span className={this.state.cnt === 8 ? "txt" : "hide"}>다음 안내</span>
                  </p>
                </div>
                <div className="page">
                  <ul className="pagination modal">
                    <li className={this.state.cnt === 1 ? "location" : "num"}></li>
                    <li className={this.state.cnt === 2 ? "location" : "num"}></li>
                    <li className={this.state.cnt === 3 ? "location" : "num"}></li>
                    <li className={this.state.cnt === 4 ? "location" : "num"}></li>
                    <li className={this.state.cnt === 5 ? "location" : "num"}></li>
                    <li className={this.state.cnt === 6 ? "location" : "num"}></li>
                    <li className={this.state.cnt === 7 ? "location" : "num"}></li>
                    <li className={this.state.cnt === 8 ? "location" : "num"}></li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="btn_close">
              <button
                onClick={event => {
                  layerStore.setChangeOnboardingStep("");
                  this.setState({ cnt: 1 });
                }}
              >
                <span>닫기</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default OnboardingStep_03;
